import { useMemo } from 'react';
import { hexToRGBA } from '@srcDS/utils/hexToRGBA';
import {
  ButtonColorStyle, ContainerStyle,
  CountdownStylesProps,
  ParsedStyles,
  TimerOrderStyle,
} from '@srcDS/components/atoms/countdown/CountdownProps';

export const useCountdownStyles = (props: CountdownStylesProps) => {
  const {
    textStyles,
    countTextStyles,
    buttonColor,
    countdownBackground,
    numberBackground,
    numberOpacity,
    numberColor,
    textColor,
  } = props;

  const parsedTextStyles = useMemo(() => textStyles && (JSON.parse(textStyles) as ParsedStyles), [textStyles]);
  const parsedCountTextStyles = useMemo(
    () => countTextStyles && (JSON.parse(countTextStyles) as ParsedStyles),
    [countTextStyles],
  );

  const buttonColorStyle = useMemo((): ButtonColorStyle => {
    if (!parsedTextStyles) return {};

    return {
      '--sm-button-color': buttonColor ?? parsedTextStyles.Mobile.color,
      '--md-button-color': buttonColor ?? parsedTextStyles.Tablet.color,
      '--lg-button-color': buttonColor ?? parsedTextStyles.Desktop.color,
    };
  }, [buttonColor, parsedTextStyles]);

  const timerOrderStyle = useMemo((): TimerOrderStyle => {
    if (!parsedCountTextStyles) return {};

    return {
      '--sm-order': parsedCountTextStyles.Mobile.order,
      '--md-order': parsedCountTextStyles.Tablet.order,
      '--lg-order': parsedCountTextStyles.Desktop.order,
    };
  }, [parsedCountTextStyles]);

  const containerStyles = useMemo(
    (): ContainerStyle => ({
      '--timerBackground': countdownBackground,
      '--numberBackground': numberBackground && hexToRGBA(numberBackground, numberOpacity ? numberOpacity / 100 : 0),
      '--numberColor': numberColor,
      '--textColor': textColor,
    }),
    [countdownBackground, numberBackground, numberOpacity, numberColor, textColor],
  );

  return {
    parsedTextStyles,
    parsedCountTextStyles,
    buttonColorStyle,
    timerOrderStyle,
    containerStyles,
  };
};
